import { useState } from "react";

export interface SortState {
  key: string;
  dir: "asc" | "desc";
}

/**
 * Sort state for a directory table. `toggleSort(key)` flips direction when
 * the same column is re-clicked, otherwise switches column (asc).
 *
 * The state is passed to the list hook as `sort`/`dir` query params, so
 * ordering is applied server-side across ALL pages (the cursor paginates on
 * the sorted column). Callers must reset their page cursor when it changes.
 */
export function useTableSort(initialKey: string, initialDir: SortState["dir"] = "asc") {
  const [sort, setSort] = useState<SortState>({ key: initialKey, dir: initialDir });

  function toggleSort(key: string) {
    setSort((s) =>
      s.key === key ? { key, dir: s.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" },
    );
  }

  return { sort, toggleSort };
}
